"use client";

import { FC, useContext } from "react";
import { useRuntimeConfig } from "@finbackoffice/site-core";
import Translate from "components/base/translate/Translate";
import { FooterContext } from "components/footer/Footer";
import Img from "components/base/img/Img";
import { AssetsDirectory } from "@finbackoffice/enums";
import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import LicenseLogo from "components/footer/license-logo/LicenseLogo";
import PromotionsDefaultList from "components/bonuses/promotions/list/PromotionsDefaultList";
import styles from "./default.module.sass";

const Default: FC = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const VERSION = useRuntimeConfig("VERSION");

    const {
        enabledPoliciesConfig,
        renderPromotionsLink,
        renderPoliciesLink,
        renderSportLinks,
        renderCasinoLinks,
        renderSocialLinksSection,
        renderCurrenciesSection,
        renderExchangeRateSection,
    } = useContext(FooterContext);

    return (
        <footer className={styles.footer}>
            <nav className={styles.nav}>
                {COMMON_SITE_CONFIGS.contentVerticals.sport && (
                    <div>
                        <h2>
                            <Translate tid="footer_sports" />
                        </h2>
                        {renderSportLinks}
                    </div>
                )}

                {(COMMON_SITE_CONFIGS.contentVerticals.livecasino ||
                    COMMON_SITE_CONFIGS.contentVerticals.slots) && (
                    <div>
                        <h2>
                            <Translate tid="footer_casino" />
                        </h2>
                        {renderCasinoLinks}
                    </div>
                )}

                <div>
                    <h2>
                        <Translate tid="footer_bonuses" />
                    </h2>
                    {renderPromotionsLink}
                    <PromotionsDefaultList />
                </div>
                <div>
                    <h2>
                        <Translate tid="footer_help_center" />
                    </h2>
                    {enabledPoliciesConfig.map(renderPoliciesLink)}
                </div>
            </nav>
            {renderCurrenciesSection}
            {renderSocialLinksSection}
            {renderExchangeRateSection}
            <div className={styles.footerText}>
                {COMMON_SITE_CONFIGS.license.enable && (
                    <ErrorBoundary name={LicenseLogo.name}>
                        <LicenseLogo />
                    </ErrorBoundary>
                )}
                <Translate
                    tid="footer_copyright_text"
                    dangerous
                    replace={{ app_name: COMMON_SITE_CONFIGS.appName }}>
                    <span className={styles.txt} />
                </Translate>
            </div>
            <div className={styles.footerLogo}>
                <Img
                    source={`/${AssetsDirectory.Mobile}/logo.svg`}
                    width={0}
                    height={0}
                    style={{ width: "100%", height: "auto" }}
                    alt={`${COMMON_SITE_CONFIGS.appName} logo`}
                    title={`${COMMON_SITE_CONFIGS.appName} logo`}
                    prefixAppName
                />
                <h1>
                    <Translate
                        tid="footer_headText"
                        replace={{ app_name: COMMON_SITE_CONFIGS.appName }}
                    />
                </h1>
            </div>
            <div className={styles.footerSite}>{`© ${new Date().getFullYear()} ${
                COMMON_SITE_CONFIGS.appName
            }`}</div>
            <div className={styles.version}>
                <Translate tid="footer_version" replace={{ version: VERSION }} />
            </div>
        </footer>
    );
};

export default Default;
